<template>
  <transition
    enter-active-class="transition-opacity duration-300 ease-out"
    enter-from-class="opacity-0"
    enter-to-class="opacity-100"
    leave-active-class="transition-opacity duration-[450ms] ease-in"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="show"
      class="fixed inset-0 z-[60] flex items-center justify-center bg-[#EBECEF]"
      aria-label="Cargando"
    >
      <div ref="lottieContainer" class="w-[195px] h-[195px] sm:w-[240px] sm:h-[240px]"></div>
    </div>
  </transition>
</template>

<script>
import lottie from 'lottie-web'

export default {
  name: 'LoginTransition',
  props: {
    show: { type: Boolean, default: false }
  },
  data() {
    return {
      animation: null
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.$nextTick(() => this.startLottie())
      } else {
        this.destroyLottie()
      }
    }
  },
  methods: {
    startLottie() {
      this.destroyLottie()
      if (!this.$refs.lottieContainer) return
      this.animation = lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: '/lotties/logo-julmar.json'
      })
    },
    destroyLottie() {
      if (this.animation) {
        try { this.animation.destroy() } catch (e) { /* noop */ }
        this.animation = null
      }
    }
  },
  beforeUnmount() {
    this.destroyLottie()
  }
}
</script>
